import {call, put, takeLatest, fork, all, delay} from 'redux-saga/effects';
import {LOCATION_DELETE_ACTION, LOCATION_DELETE_FAIL, LOCATION_LIST_ACTION, LOCATION_LIST_FAIL, LOCATION_DETAIL_ACTION, LOCATION_DETAIL_FAIL, LOCATION_SAVE_ACTION, LOCATION_SAVE_FAIL} from '../constants/Types';
import * as LocationService from './../services/locationService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {message} from 'antd'
import { setListLocations as setListLocationsAction, setLocation as setLocationAction, saveLocationSuccess } from './../actions/locationAction';
import {PATHS} from "./../constants/Define";
import { omit } from 'lodash';
import {SAGA_DELAY_TIMEOUT} from '../constants/Define';
import history from '../helpers/history';

function* setListLocationSaga() {
    yield takeLatest(LOCATION_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize : undefined;
        // const pageIndex = action.filters.pageIndex ? (action.filters.pageIndex - 1) * pageSize : undefined;
        const pageIndex = action.filters.pageIndex - 1;
        const orderByDesc = true;
        const params = {
            ...omit(action.filters, ['pageIndex', 'pageSize']),
            orderByDesc, pageSize, pageIndex,
        }
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(LocationService.getLocations, params);
        yield put(setListLocationsAction(result));
    }, errorHandleLocation(LOCATION_LIST_FAIL)))
}

function* setLocationSaga() {
    yield takeLatest(LOCATION_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(LocationService.getLocation, action.id);
        yield put(setLocationAction(result));
    }, errorHandleLocation(LOCATION_DETAIL_FAIL)))
}

function* saveLocationSaga() {
    yield takeLatest(LOCATION_SAVE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(LocationService.saveLocation, action.location);
        message.success(i18n.t(`validation.statusCode.code.${action.location.id ? '204':'201'}`));
        yield put(saveLocationSuccess(result));
        history.push(PATHS.LOCATION.LIST.path);
        history.go();
    }, errorHandleLocation(LOCATION_SAVE_FAIL)))
}

function* deleteLocationSaga() {
    yield takeLatest(LOCATION_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(LocationService.deleteLocation, action.location);
        history.push(PATHS.LOCATION.LIST.path);
        history.go();
    }, errorHandleLocation(LOCATION_DELETE_FAIL)))
}

function errorHandleLocation(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'location');
}

export function* locationSaga() {
    yield all([
        fork(setListLocationSaga),
        fork(setLocationSaga),
        fork(saveLocationSaga),
        fork(deleteLocationSaga)
    ])
}
